<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Cashier">
                                        <a-select v-model="inputCashier" showSearch placeholder="All Cashiers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in cashierOptions" :key="option.id" :value="option.id">{{option.first_name}} {{option.last_name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputCashier: 0,
                site_type: "ho",
                siteOptions: [],
                cashierOptions: [],
                birSalesReports: [],
                JsonData: [],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.reportDescription = await getReportDescription(this.currentProfile)

            let users = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_valid_cashiers', null);
            component_x.cashierOptions = users;
            component_x.cashierOptions.push({id: 0, first_name: ' All Users', last_name: ''})
            component_x.cashierOptions.sort(function (a, b) {
                let aname = a.first_name + ' ' + a.last_name
                let bname = b.first_name + ' ' + b.last_name
                return aname.localeCompare(bname);
            });
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'eod_by_cashier?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&user_id=' + this.inputCashier, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(var x=0; x < siteSpecific.length; x++){
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        
                        doc.text(15,design_y,`EOD by Cashier and POS Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        design_y = design_y + 10;
                        doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[x].site_code + " " + siteSpecific[x].report_details[0].site_name)

                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 40},
                            1: {cellWidth: 40},
                            2: {cellWidth: 30},
                            3: {cellWidth: 30},
                            4: {cellWidth: 30},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30}
                        } 

                        let header = [
                            {content: 'Terminal', styles: {halign: 'center'}},
                            {content: 'Tender', styles: {halign: 'center'}},
                            {content: 'Docket\nCount', styles: {halign: 'center'}},
                            {content: 'Pick Up', styles: {halign: 'center'}},
                            {content: 'Fund', styles: {halign: 'center'}},
                            {content: 'Sales', styles: {halign: 'center'}},
                            {content: 'Refund', styles: {halign: 'center'}},
                            {content: 'Expected', styles: {halign: 'center'}},
                            {content: 'Declared', styles: {halign: 'center'}},
                            {content: 'Difference', styles: {halign: 'center'}}
                        ]

                        if(this.birSalesReports.length > 0){
                            let reportData = []
                            let grouper = 'start'
                            let sub_grouper = 'start'
                            
                            let sub_docket = 0
                            let sub_pickup = 0
                            let sub_fund = 0
                            let sub_sales = 0
                            let sub_refund = 0
                            let sub_expected = 0
                            let sub_declared = 0

                            let total_docket = 0
                            let total_pickup = 0
                            let total_fund = 0
                            let total_sales = 0
                            let total_refund = 0
                            let total_expected = 0
                            let total_declared = 0

                            let parent_sub_docket = 0
                            let parent_sub_pickup = 0
                            let parent_sub_fund = 0
                            let parent_sub_sales = 0
                            let parent_sub_refund = 0
                            let parent_sub_expected = 0
                            let parent_sub_declared = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                let grouper_name = moment(reportLine.business_date).format('MM/DD/YYYY')
                                let sub_grouper_name = reportLine.cashier_name
                                if(grouper == 'start'){
                                    let detail_header = [{content: `Business Date: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))

                                    let sub_detail_header = [{content: sub_grouper_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, sub_detail_header))
                                } else {
                                    if(grouper != reportLine.business_date){
                                        let detail_header = [{content: `Business Date: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))

                                        let sub_detail_header = [{content: sub_grouper_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, sub_detail_header))
                                    } else {
                                        if(sub_grouper != reportLine.cashier_name){
                                            let sub_detail_header = [{content: sub_grouper_name, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, sub_detail_header))
                                        }
                                    }
                                }

                                grouper = reportLine.business_date
                                sub_grouper = reportLine.cashier_name

                                //body
                                let detail = []
                                
                                let sales = Number(reportLine.sales)
                                let withdrawal = Number(reportLine.withdrawal)
                                let expected = sales - withdrawal

                                let declaration = Number(reportLine.declaration)
                                let diff = declaration - expected
                                detail.push(
                                    {content: reportLine.terminal_name, styles: {halign: 'left'}},
                                    {content: reportLine.payment_type, styles: {halign: 'left'}},
                                    this.formatNumber(Number(reportLine.docket)),
                                    this.convertToCurrency(Number(reportLine.withdrawal)),
                                    this.convertToCurrency(Number(reportLine.initfund)),
                                    this.convertToCurrency(Number(reportLine.sales)),
                                    this.convertToCurrency(Number(reportLine.refund)),
                                    this.convertToCurrency(expected),
                                    this.convertToCurrency(declaration),
                                    this.convertToCurrency(diff)
                                )

                                sub_docket += Number(reportLine.docket)
                                sub_pickup += withdrawal
                                sub_fund += Number(reportLine.initfund)
                                sub_sales += Number(reportLine.sales)
                                sub_refund += Number(reportLine.refund)
                                sub_expected += expected
                                sub_declared += declaration

                                parent_sub_docket += Number(reportLine.docket)
                                parent_sub_pickup += withdrawal
                                parent_sub_fund += Number(reportLine.initfund)
                                parent_sub_sales += Number(reportLine.sales)
                                parent_sub_refund += Number(reportLine.refund)
                                parent_sub_expected += expected
                                parent_sub_declared += declaration

                                total_docket += Number(reportLine.docket)
                                total_pickup += withdrawal
                                total_fund += Number(reportLine.initfund)
                                total_sales += Number(reportLine.sales)
                                total_refund += Number(reportLine.refund)
                                total_expected += expected
                                total_declared += declaration

                                reportData.push(detail)
                                
                                let total_detail = []
                                let parent_sub_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    let sub_diff = sub_declared - sub_expected
                                    let parent_sub_diff = parent_sub_declared - parent_sub_expected
                                    let total_diff = total_declared - total_expected

                                    sub_detail = [
                                        {content: 'Total By :', styles: {halign: 'left'}},
                                        {content: sub_grouper_name, styles: {halign: 'left'}},
                                        this.formatNumber(sub_docket),
                                        this.convertToCurrency(sub_pickup),
                                        this.convertToCurrency(sub_fund),
                                        this.convertToCurrency(sub_sales),
                                        this.convertToCurrency(sub_refund),
                                        this.convertToCurrency(sub_expected),
                                        this.convertToCurrency(sub_declared),
                                        this.convertToCurrency(sub_diff)
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(sub_detail)

                                    parent_sub_detail = [
                                        {content: 'Total By :', styles: {halign: 'left'}},
                                        {content: grouper_name, styles: {halign: 'left'}},
                                        this.formatNumber(parent_sub_docket),
                                        this.convertToCurrency(parent_sub_pickup),
                                        this.convertToCurrency(parent_sub_fund),
                                        this.convertToCurrency(parent_sub_sales),
                                        this.convertToCurrency(parent_sub_refund),
                                        this.convertToCurrency(parent_sub_expected),
                                        this.convertToCurrency(parent_sub_declared),
                                        this.convertToCurrency(parent_sub_diff)
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(parent_sub_detail)

                                    total_detail = [
                                        {content: 'Total By :', styles: {halign: 'left'}},
                                        {content: reportLine.site_name, styles: {halign: 'left'}},
                                        this.formatNumber(total_docket),
                                        this.convertToCurrency(total_pickup),
                                        this.convertToCurrency(total_fund),
                                        this.convertToCurrency(total_sales),
                                        this.convertToCurrency(total_refund),
                                        this.convertToCurrency(total_expected),
                                        this.convertToCurrency(total_declared),
                                        this.convertToCurrency(total_diff)
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(total_detail)

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[0].content == 'Total By :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    let parent_current_grouper = ""
                                    let parent_next_grouper = ""

                                    let current_grouper = ""
                                    let next_grouper = ""

                                    parent_current_grouper = reportLine.business_date
                                    parent_next_grouper = this.birSalesReports[i+1].business_date

                                    current_grouper = reportLine.cashier_name
                                    next_grouper = this.birSalesReports[i+1].cashier_name
                                    
                                    if(parent_current_grouper != parent_next_grouper){
                                        let sub_diff = sub_declared - sub_expected

                                        sub_detail = [
                                            {content: 'Total By :', styles: {halign: 'left'}},
                                            {content: sub_grouper_name, styles: {halign: 'left'}},
                                            this.formatNumber(sub_docket),
                                            this.convertToCurrency(sub_pickup),
                                            this.convertToCurrency(sub_fund),
                                            this.convertToCurrency(sub_sales),
                                            this.convertToCurrency(sub_refund),
                                            this.convertToCurrency(sub_expected),
                                            this.convertToCurrency(sub_declared),
                                            this.convertToCurrency(sub_diff)
                                        ]

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(sub_detail)

                                        sub_docket = 0
                                        sub_pickup = 0
                                        sub_fund = 0
                                        sub_sales = 0
                                        sub_refund = 0
                                        sub_expected = 0
                                        sub_declared = 0

                                        let parent_sub_diff = parent_sub_declared - parent_sub_expected

                                        parent_sub_detail = [
                                            {content: 'Total By :', styles: {halign: 'left'}},
                                            {content: grouper_name, styles: {halign: 'left'}},
                                            this.formatNumber(parent_sub_docket),
                                            this.convertToCurrency(parent_sub_pickup),
                                            this.convertToCurrency(parent_sub_fund),
                                            this.convertToCurrency(parent_sub_sales),
                                            this.convertToCurrency(parent_sub_refund),
                                            this.convertToCurrency(parent_sub_expected),
                                            this.convertToCurrency(parent_sub_declared),
                                            this.convertToCurrency(parent_sub_diff)
                                        ]

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(parent_sub_detail)

                                        parent_sub_docket = 0
                                        parent_sub_pickup = 0
                                        parent_sub_fund = 0
                                        parent_sub_sales = 0
                                        parent_sub_refund = 0
                                        parent_sub_expected = 0
                                        parent_sub_declared = 0
                                    } else {
                                        if(current_grouper != next_grouper){
                                            let sub_diff = sub_declared - sub_expected

                                            sub_detail = [
                                                {content: 'Total By :', styles: {halign: 'left'}},
                                                {content: sub_grouper_name, styles: {halign: 'left'}},
                                                this.formatNumber(sub_docket),
                                                this.convertToCurrency(sub_pickup),
                                                this.convertToCurrency(sub_fund),
                                                this.convertToCurrency(sub_sales),
                                                this.convertToCurrency(sub_refund),
                                                this.convertToCurrency(sub_expected),
                                                this.convertToCurrency(sub_declared),
                                                this.convertToCurrency(sub_diff)
                                            ]

                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(sub_detail)

                                            sub_docket = 0
                                            sub_pickup = 0
                                            sub_fund = 0
                                            sub_sales = 0
                                            sub_refund = 0
                                            sub_expected = 0
                                            sub_declared = 0
                                        }   
                                    }
                                }
                            }
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }

                    //doc.save(`EOD_By_Cashier_And_POS_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'eod_by_cashier?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&user_id=' + this.inputCashier, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(get_request.length > 0){
                    let site_specific = [];
                    let grouper = ''
                    let headers = ['Terminal','Tender','Docket Count','Pick Up','Fund','Sales','Refund','Expected','Declared','Difference']

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = []
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'
                            let sub_grouper = 'start'
                            
                            let sub_docket = 0
                            let sub_pickup = 0
                            let sub_fund = 0
                            let sub_sales = 0
                            let sub_refund = 0
                            let sub_expected = 0
                            let sub_declared = 0

                            let total_docket = 0
                            let total_pickup = 0
                            let total_fund = 0
                            let total_sales = 0
                            let total_refund = 0
                            let total_expected = 0
                            let total_declared = 0

                            let parent_sub_docket = 0
                            let parent_sub_pickup = 0
                            let parent_sub_fund = 0
                            let parent_sub_sales = 0
                            let parent_sub_refund = 0
                            let parent_sub_expected = 0
                            let parent_sub_declared = 0
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                let grouper_name = moment(reportLine.business_date).format('MM/DD/YYYY')
                                let sub_grouper_name = reportLine.cashier_name
                                if(grouper == 'start'){
                                    let detail_header = [`Business Date: ${grouper_name}`];
                                    reportData.push(Object.assign({}, detail_header))

                                    let sub_detail_header = [sub_grouper_name];
                                    reportData.push(Object.assign({}, sub_detail_header))
                                } else {
                                    if(grouper != reportLine.business_date){
                                        let detail_header = [`Business Date: ${grouper_name}`];
                                        reportData.push(Object.assign({}, detail_header))

                                        let sub_detail_header = [sub_grouper_name];
                                        reportData.push(Object.assign({}, sub_detail_header))
                                    } else {
                                        if(sub_grouper != reportLine.cashier_name){
                                            let sub_detail_header = [sub_grouper_name];
                                            reportData.push(Object.assign({}, sub_detail_header))
                                        }
                                    }
                                }

                                grouper = reportLine.business_date
                                sub_grouper = reportLine.cashier_name

                                //body
                                let detail = []
                                
                                let sales = Number(reportLine.sales)
                                let withdrawal = Number(reportLine.withdrawal)
                                let expected = sales - withdrawal

                                let declaration = Number(reportLine.declaration)
                                let diff = declaration - expected
                                detail.push(reportLine.terminal_name, reportLine.payment_type,
                                    this.formatNumber(Number(reportLine.docket)),
                                    this.convertToCurrency(Number(reportLine.withdrawal)),
                                    this.convertToCurrency(Number(reportLine.initfund)),
                                    this.convertToCurrency(Number(reportLine.sales)),
                                    this.convertToCurrency(Number(reportLine.refund)),
                                    this.convertToCurrency(expected),
                                    this.convertToCurrency(declaration),
                                    this.convertToCurrency(diff)
                                )

                                sub_docket += Number(reportLine.docket)
                                sub_pickup += withdrawal
                                sub_fund += Number(reportLine.initfund)
                                sub_sales += Number(reportLine.sales)
                                sub_refund += Number(reportLine.refund)
                                sub_expected += expected
                                sub_declared += declaration

                                parent_sub_docket += Number(reportLine.docket)
                                parent_sub_pickup += withdrawal
                                parent_sub_fund += Number(reportLine.initfund)
                                parent_sub_sales += Number(reportLine.sales)
                                parent_sub_refund += Number(reportLine.refund)
                                parent_sub_expected += expected
                                parent_sub_declared += declaration

                                total_docket += Number(reportLine.docket)
                                total_pickup += withdrawal
                                total_fund += Number(reportLine.initfund)
                                total_sales += Number(reportLine.sales)
                                total_refund += Number(reportLine.refund)
                                total_expected += expected
                                total_declared += declaration

                                reportData.push(detail)
                                
                                let total_detail = []
                                let parent_sub_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    let sub_diff = sub_declared - sub_expected
                                    let parent_sub_diff = parent_sub_declared - parent_sub_expected
                                    let total_diff = total_declared - total_expected

                                    sub_detail = ['Total By :',sub_grouper_name,
                                        this.formatNumber(sub_docket),
                                        this.convertToCurrency(sub_pickup),
                                        this.convertToCurrency(sub_fund),
                                        this.convertToCurrency(sub_sales),
                                        this.convertToCurrency(sub_refund),
                                        this.convertToCurrency(sub_expected),
                                        this.convertToCurrency(sub_declared),
                                        this.convertToCurrency(sub_diff)
                                    ]

                                    reportData.push(sub_detail)

                                    parent_sub_detail = ['Total By :',
                                        grouper_name,
                                        this.formatNumber(parent_sub_docket),
                                        this.convertToCurrency(parent_sub_pickup),
                                        this.convertToCurrency(parent_sub_fund),
                                        this.convertToCurrency(parent_sub_sales),
                                        this.convertToCurrency(parent_sub_refund),
                                        this.convertToCurrency(parent_sub_expected),
                                        this.convertToCurrency(parent_sub_declared),
                                        this.convertToCurrency(parent_sub_diff)
                                    ]

                                    reportData.push(parent_sub_detail)

                                    total_detail = ['Total By :',reportLine.site_name,
                                        this.formatNumber(total_docket),
                                        this.convertToCurrency(total_pickup),
                                        this.convertToCurrency(total_fund),
                                        this.convertToCurrency(total_sales),
                                        this.convertToCurrency(total_refund),
                                        this.convertToCurrency(total_expected),
                                        this.convertToCurrency(total_declared),
                                        this.convertToCurrency(total_diff)
                                    ]

                                    reportData.push(total_detail)

                                } else {
                                    let parent_current_grouper = ""
                                    let parent_next_grouper = ""

                                    let current_grouper = ""
                                    let next_grouper = ""

                                    parent_current_grouper = reportLine.business_date
                                    parent_next_grouper = this.birSalesReports[i+1].business_date

                                    current_grouper = reportLine.cashier_name
                                    next_grouper = this.birSalesReports[i+1].cashier_name
                                    
                                    if(parent_current_grouper != parent_next_grouper){
                                        let sub_diff = sub_declared - sub_expected

                                        sub_detail = ['Total By :', sub_grouper_name,
                                            this.formatNumber(sub_docket),
                                            this.convertToCurrency(sub_pickup),
                                            this.convertToCurrency(sub_fund),
                                            this.convertToCurrency(sub_sales),
                                            this.convertToCurrency(sub_refund),
                                            this.convertToCurrency(sub_expected),
                                            this.convertToCurrency(sub_declared),
                                            this.convertToCurrency(sub_diff)
                                        ]

                                        reportData.push(sub_detail)

                                        sub_docket = 0
                                        sub_pickup = 0
                                        sub_fund = 0
                                        sub_sales = 0
                                        sub_refund = 0
                                        sub_expected = 0
                                        sub_declared = 0

                                        let parent_sub_diff = parent_sub_declared - parent_sub_expected

                                        parent_sub_detail = ['Total By :',grouper_name,
                                            this.formatNumber(parent_sub_docket),
                                            this.convertToCurrency(parent_sub_pickup),
                                            this.convertToCurrency(parent_sub_fund),
                                            this.convertToCurrency(parent_sub_sales),
                                            this.convertToCurrency(parent_sub_refund),
                                            this.convertToCurrency(parent_sub_expected),
                                            this.convertToCurrency(parent_sub_declared),
                                            this.convertToCurrency(parent_sub_diff)
                                        ]

                                        reportData.push(parent_sub_detail)

                                        parent_sub_docket = 0
                                        parent_sub_pickup = 0
                                        parent_sub_fund = 0
                                        parent_sub_sales = 0
                                        parent_sub_refund = 0
                                        parent_sub_expected = 0
                                        parent_sub_declared = 0
                                    } else {
                                        if(current_grouper != next_grouper){
                                            let sub_diff = sub_declared - sub_expected

                                            sub_detail = ['Total By :',sub_grouper_name,
                                                this.formatNumber(sub_docket),
                                                this.convertToCurrency(sub_pickup),
                                                this.convertToCurrency(sub_fund),
                                                this.convertToCurrency(sub_sales),
                                                this.convertToCurrency(sub_refund),
                                                this.convertToCurrency(sub_expected),
                                                this.convertToCurrency(sub_declared),
                                                this.convertToCurrency(sub_diff)
                                            ]

                                            reportData.push(sub_detail)

                                            sub_docket = 0
                                            sub_pickup = 0
                                            sub_fund = 0
                                            sub_sales = 0
                                            sub_refund = 0
                                            sub_expected = 0
                                            sub_declared = 0
                                        }   
                                    }
                                }
                            }
                            
                        }
                        
                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>